var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showType == 'form-builder')?_c('b-form-group',{style:(_vm.properties.style),attrs:{"description":_vm.properties.description,"label":_vm.properties.label}},[_c('b-form-radio-group',{attrs:{"stacked":!_vm.properties.showInline}},_vm._l((_vm.fBOptions),function(option,optionIndex){return _c('b-form-radio',{key:optionIndex,class:_vm.properties.showInline ? 'mr-3' : '',attrs:{"value":option}},[_vm._v(_vm._s(option))])}),1)],1):_vm._e(),(_vm.showType == 'properties')?_c('div',[_c('single-choice-v1-properties',{attrs:{"formId":_vm.formId}})],1):_vm._e(),(
      _vm.showType == 'form-submitter' ||
        (_vm.showType == 'e-form' && _vm.properties.eFormEditable)
    )?_c('b-form-group',{staticStyle:{"font-size":"14px"},style:(_vm.properties.style),attrs:{"description":_vm.computedConditions.description
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: _vm.properties.description,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.description,"label":_vm.computedConditions.label
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: _vm.properties.label,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.label,"hidden":_vm.computedHidden,"state":_vm.state,"invalid-feedback":_vm.errors.join(', ')}},[_c('b-form-radio-group',{attrs:{"stacked":!_vm.properties.showInline},model:{value:(_vm.controlValue),callback:function ($$v) {_vm.controlValue=$$v},expression:"controlValue"}},_vm._l((_vm.computedConditions.options
          ? _vm.superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'options',
              value: _vm.properties.options,
              defaultValue: [],
              form: this.form
            })
          : _vm.properties.options),function(option,optionIndex){return _c('b-form-radio',{key:optionIndex,class:_vm.properties.showInline ? 'mr-3' : '',staticStyle:{"font-size":"14px"},attrs:{"value":option}},[_vm._v(_vm._s(option))])}),1)],1):_vm._e(),(
      _vm.showType == 'form-viewer' ||
        (_vm.showType == 'e-form' && !_vm.properties.eFormEditable)
    )?_c('b-form-group',{style:(_vm.properties.style),attrs:{"label":_vm.computedConditions.label
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: _vm.properties.label,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.label}},[_c('div',{class:_vm.properties.showInline ? 'd-flex flex-row flex-wrap' : ''},_vm._l((_vm.computedConditions.options
          ? _vm.superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'options',
              value: _vm.properties.options,
              defaultValue: [],
              form: this.form
            })
          : _vm.properties.options),function(option,optionIndex){return _c('div',{key:optionIndex,staticClass:"mr-3",attrs:{"value":option}},[(_vm.controlValue == option)?_c('b-icon-check-circle-fill',{staticClass:"text-primary"}):_c('b-icon-circle'),_vm._v(" "+_vm._s(option)+" ")],1)}),0)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }